<acf>
  return component('hero-image', [
    'label' => 'Hero Background Video',
    'sub_fields' => [
      text_field(),
      image_field(),
      text_field('video_url'),
    ]
  ]);
</acf>

<php>
  return function ($content) {
    $content['field_HeroImage_image'] = wp_get_attachment_url($content['field_HeroImage_image']);

    return $content;
  };
</php>

<script>
  export default {
    props: ['content'],

    mounted() {
      document.getElementById('app').classList.add('white')
    },

    computed: {
      backgroundImage() {
        return `url(${this.content.field_HeroImage_image})`
      }
    }
  }
</script>
<template>
  <section class="section" :style="{ backgroundImage }">
    <div class="screen1" />
    <div class="screen2" />
    <video class="video" :src="content.field_HeroImage_video_url" width="1920" height="1080" autoplay muted loop />
    <div class="text is-size-3">{{ content.field_HeroImage_Text }}</div>
  </section>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .section {
    min-height: calc(100vh - 100px);
    margin-top: -130px;
    @include mobile { margin-top: -186px; }
    background: top center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
  }

  .video, .screen1, .screen2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .video {
    pointer-events: none;
    z-index: 0;
    object-fit: cover;
    max-width: none;
  }

  .screen1 {
    background: rgba(6,6,6,0.30);
    z-index: 1;
  }

  .screen2 {
    opacity: 0.55;
    background-image: linear-gradient(-180deg, rgba(0,0,0,0.00) 0%, #000000 100%);
    z-index: 2;
  }

  .text {
    color: white;
    max-width: 450px;
    text-align: center;
    position: relative;
    z-index: 3;
  }
</style>



// WEBPACK FOOTER //
// components/HeroImage.vue